export default "__VITE_ASSET__CStVKkDo__"